import { useMemo } from 'react';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var IDB_KEY = "__idb";

/*
 * Taken From https://stackoverflow.com/a/69614443/4377220
 * for good DX + SSR
 */
var waitUntil = function waitUntil(condition, options) {
  return new Promise(function (resolve, reject) {
    var interval = setInterval(function () {
      if (!condition()) return;
      clearInterval(interval);
      resolve();
    }, (options == null ? void 0 : options.tick) || 100);
    setTimeout(function () {
      clearInterval(interval);
      reject("your error msg");
    }, (options == null ? void 0 : options.timeout) || 10000);
  });
};

function validateStore(db, storeName) {
  return db.objectStoreNames.contains(storeName);
}

function validateBeforeTransaction(db, storeName, reject) {
  if (!db) {
    reject("Queried before opening connection");
  }

  if (!validateStore(db, storeName)) {
    reject("Store " + storeName + " not found");
  }
}
function createTransaction(db, dbMode, currentStore, resolve, reject, abort) {
  var tx = db.transaction(currentStore, dbMode);
  tx.onerror = reject;
  tx.oncomplete = resolve;
  tx.onabort = abort;
  return tx;
}
function getConnection(_x) {
  return _getConnection.apply(this, arguments);
}

function _getConnection() {
  _getConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
    var idbInstance, _config, _window$IDB_KEY2;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            idbInstance = typeof window !== "undefined" ? window.indexedDB : null;
            _config = config;

            if (!(!config && idbInstance)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return waitUntil(function () {
              var _window, _window$IDB_KEY;

              return ((_window = window) == null ? void 0 : (_window$IDB_KEY = _window[IDB_KEY]) == null ? void 0 : _window$IDB_KEY["init"]) === 1;
            });

          case 5:
            _config = (_window$IDB_KEY2 = window[IDB_KEY]) == null ? void 0 : _window$IDB_KEY2["config"];

          case 6:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (idbInstance) {
                var request = idbInstance.open(_config.databaseName, _config.version);

                request.onsuccess = function () {
                  resolve(request.result);
                };

                request.onerror = function (e) {
                  reject(e.target.error.name);
                };

                request.onupgradeneeded = function (e) {
                  var db = e.target.result;
                  config.stores.forEach(function (s) {
                    if (!db.objectStoreNames.contains(s.name)) {
                      var store = db.createObjectStore(s.name, s.id);
                      s.indices.forEach(function (c) {
                        store.createIndex(c.name, c.keyPath, c.options);
                      });
                    }
                  });
                  db.close();
                  resolve(undefined);
                };
              } else {
                reject("Failed to connect");
              }
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getConnection.apply(this, arguments);
}

function getActions(currentStore) {
  return {
    getByID: function getByID(id) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readonly", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.get(id);

          request.onsuccess = function (e) {
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    getOneByKey: function getOneByKey(keyPath, value) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readonly", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var index = objectStore.index(keyPath);
          var request = index.get(value);

          request.onsuccess = function (e) {
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    getManyByKey: function getManyByKey(keyPath, value) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readonly", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var index = objectStore.index(keyPath);
          var request = index.getAll(value);

          request.onsuccess = function (e) {
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    getAll: function getAll() {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readonly", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.getAll();

          request.onsuccess = function (e) {
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    add: function add(value, key) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readwrite", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.add(value, key);

          request.onsuccess = function (e) {
            tx == null ? void 0 : tx.commit == null ? void 0 : tx.commit();
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    update: function update(value, key) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readwrite", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.put(value, key);

          request.onsuccess = function (e) {
            tx == null ? void 0 : tx.commit == null ? void 0 : tx.commit();
            resolve(e.target.result);
          };
        })["catch"](reject);
      });
    },
    deleteByID: function deleteByID(id) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readwrite", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore["delete"](id);

          request.onsuccess = function (e) {
            tx == null ? void 0 : tx.commit == null ? void 0 : tx.commit();
            resolve(e);
          };
        })["catch"](reject);
      });
    },
    deleteAll: function deleteAll() {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readwrite", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.clear();

          request.onsuccess = function (e) {
            tx == null ? void 0 : tx.commit == null ? void 0 : tx.commit();
            resolve(e);
          };
        })["catch"](reject);
      });
    },
    openCursor: function openCursor(cursorCallback, keyRange) {
      return new Promise(function (resolve, reject) {
        getConnection().then(function (db) {
          validateBeforeTransaction(db, currentStore, reject);
          var tx = createTransaction(db, "readonly", currentStore, resolve, reject);
          var objectStore = tx.objectStore(currentStore);
          var request = objectStore.openCursor(keyRange);

          request.onsuccess = function (e) {
            cursorCallback(e);
            resolve();
          };
        })["catch"](reject);
      });
    }
  };
}

function setupIndexedDB(_x) {
  return _setupIndexedDB.apply(this, arguments);
}

function _setupIndexedDB() {
  _setupIndexedDB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return getConnection(config);

                      case 3:
                        console.log("inside Init", config);
                        window[IDB_KEY] = {
                          init: 1,
                          config: config
                        };
                        resolve();
                        _context.next = 12;
                        break;

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](0);
                        console.error(_context.t0);
                        reject(_context.t0);

                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 8]]);
              }));

              return function (_x2, _x3) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setupIndexedDB.apply(this, arguments);
}

function useIndexedDBStore(storeName) {
  var _actions = useMemo(function () {
    return getActions(storeName);
  }, [storeName]);

  return _actions;
}

export default setupIndexedDB;
export { useIndexedDBStore };
//# sourceMappingURL=use-indexeddb.esm.js.map
